import { OnInit, ElementRef } from '@angular/core';
import { MatSidenav } from '@angular/material';
import { SocketService } from '@shared/services/socket.service';
import { UnsubscribeOnDestroyAdapter } from 'src/app/core/unsuscribe-adapter/unsuscribe-adapter';
import { CloseEventsComponent } from './components/close-events/close-events.component';
import { environment } from 'src/environments/environment';
import { IEvent as Event } from '@shared/models/socket.mode';
import { EtaReminderComponent } from '@shared/components/eta-reminder/eta-reminder.component';
const ɵ0 = () => x => new SocketService();
export class MainLayoutComponent extends UnsubscribeOnDestroyAdapter {
    constructor(spinnerService, iconService, socketService, autoLogoutService, dialog, userService) {
        super();
        this.spinnerService = spinnerService;
        this.iconService = iconService;
        this.dialog = dialog;
        this.userService = userService;
        this.opened = false;
        this.showChat = false;
        this.newMessages = 0;
        this.instanceOne = socketService(1);
        this.instanceTwo = socketService(2);
        this.user = this.userService.userInfo;
        this.AutoLogout = autoLogoutService;
    }
    ngOnInit() {
        this.iconService.registerIcons();
        this.socketIOInit();
        this.setSideBarStatus();
        //AutoLogoutService.call;
    }
    toggleHideSidebar() {
        this.hideSidebar = !this.hideSidebar;
        localStorage.setItem('sidebar_status', !this.hideSidebar ? 'true' : 'false');
    }
    socketIOInit() {
        // instance one
        this.instanceOne.initSocket(environment.socketUrl + '/CLIENTOPERATOR', localStorage.getItem('JWT_TOKEN'));
        this.subs.add(this.instanceOne.onEvent(Event.CONNECT).subscribe(e => { }));
        this.subs.add(this.instanceOne
            .onEvent('op-taskReminder-' + this.user.id)
            .subscribe(data => {
            data = data.response;
            if (data.user_id == this.user.id) {
                this.dialog.open(CloseEventsComponent, {
                    width: '380px',
                    data: {
                        type_event: 'close',
                        body: {
                            taskInfo: Object.assign({}, data, { email: data.email_address, phone: data.phone_number }),
                            task: data.type,
                            action: data.action_email
                                ? 'email'
                                : data.action_call
                                    ? 'call'
                                    : 'followup',
                            date: data.date,
                            id: data.id
                        }
                    },
                    hasBackdrop: false,
                    position: { top: '50px', right: '15px' },
                    panelClass: 'create-task-modal'
                });
            }
        }));
        this.subs.add(this.instanceOne
            .onEvent('op-checkConnection-all')
            .subscribe((data) => {
            localStorage.setItem('DB-DOWN', !data.response.databaseStatus ? 'YES' : 'NO');
            if (!data.response.databaseStatus) {
                // If the db is down the local Storage item DB-DOWN is YES for 40s while db is restored
                setTimeout(() => {
                    localStorage.setItem('DB-DOWN', 'NO');
                }, 40000);
            }
        }));
        this.subs.add(this.instanceOne
            .onEvent('op-orderEtaReminder-' + this.user.id)
            .subscribe((data) => {
            if (this.user.id == data.response.dispatcher_id) {
                this.showEtaReminder(data.response.fd_number);
            }
        }));
    }
    showEtaReminder(fd_number) {
        this.dialog.open(EtaReminderComponent, {
            width: '300px',
            data: { fd_number }
        });
    }
    setCounterNewMessages(event) {
        if (!this.showChat)
            this.newMessages++;
    }
    setSideBarStatus() {
        const status = JSON.parse(localStorage.getItem('sidebar_status'));
        this.expanded = status !== null ? status : false;
        localStorage.setItem('sidebar_status', this.expanded ? 'true' : 'false');
        this.hideSidebar = !this.expanded;
    }
}
export { ɵ0 };
